import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexSafeStayBannersContainerModule} from "@shopping-angular-components/flex-safe-stay-banners-container";
import { FlexSafeStayBannerWrapperComponent } from './flex-safe-stay-banner-wrapper.component';




@NgModule({
  declarations: [FlexSafeStayBannerWrapperComponent],
  exports: [
    FlexSafeStayBannerWrapperComponent
  ],
  imports: [
    CommonModule,
    FlexSafeStayBannersContainerModule
  ]
})
export class FlexSafeStayBannerWrapperModule { }
